export enum RequestSessionType {
	InPerson = 1,
	RemoteVideo = 2,
	Written = 3,
}

export enum RequestSessionStatus {
	AwaitingStart = 1,
	InProgress = 2,
	Finished = 3,
	NotHeld = 4,
	Cancelled = 5,
	AwaitingAnswers = 6,
	AnswersReceived = 7,
	NoAnswerAwaitingDecision = 8,
	ExtensionRequestAwaitingDecision = 9,
	ExcuseAwaitingDecision = 10,
}

export enum RequestSessionRecordStatus {
	Drafting = 1,
	ApprovedPendingAuthentication = 2,
	Authenticated = 3,
	AwaitingUpload = 4,
	UploadedPendingApproval = 5,
	UploadedApproved = 6,
}

export enum RequestSessionRecordOutcome {
	EndHearing = 1,
	Postponed = 2,
}

export enum RequestSessionBatchStatus {
	Waiting = 1,
	Answered = 2,
	Expired = 3,
	Closed = 4,
	Request = 5,
}

export enum RequestSessionDeadlineChangeType {
	Renotify = 1,
	Extend = 2,
}

export enum RequestSessionRespondentRequestType {
	Extension = 1,
	Excuse = 2,
}

export enum RequestSessionBatchDecision {
	ProveNonResponse = "prove-non-response",
	Renotify = "renotify",
	Extend = "extend",
	AcceptRequest = "accept-request",
	RejectRequest = "reject-request",
}

export enum RequestSessionMinutesApprovalStatus {
	Pending = 1,
	Approved = 2,
	ApprovedWithReservation = 3,
	DidNotAttend = 4,
	AutoApproved = 5,
}

export enum RequestSessionParticipantRole {
	Plaintiff = 1,
	Defendant = 2,
	CourtClerk = 3,
	CommitteeChairman = 4,
	CommitteeMemberFirst = 5,
	CommitteeMemberSecond = 6,
	PlaintiffAgent = 7,
	DefendantAgent = 8,
}

export enum RequestSessionPanelTab {
	Attendance = "attendance",
	Questions = "questions",
	Attachments = "attachments",
	Minutes = "minutes",
}

export enum RequestSessionPanelMode {
	View = "view",
	Edit = "edit",
}

export enum RequestSessionAction {
	View = "view",
	Edit = "edit",
	Start = "start",
	Join = "join",
	Approve = "approve",
	UploadMinutes = "upload-minutes",
	Reschedule = "reschedule",
	Cancel = "cancel",
	CopyLink = "copy-link",
	ViewCopy = "view-copy",
	Authenticate = "authenticate",
}
